var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M4.889 6C3.965 6 3 6.687 3 7.786v9.428C3 18.313 3.965 19 4.889 19H19.11c.924 0 1.889-.687 1.889-1.786V7.786C21 6.687 20.035 6 19.111 6H4.89ZM19 9V8H5v1h14ZM5 17v-4h14v4H5Zm3-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H8Z",
    clipRule: "evenodd"
  })));
};
export default SvgCreditCard;